import { desgloseLineas, formatClp } from './denominacionesClp';
import { formatFechaHoraChile } from './fechasChile';

function esc(s) {
    return String(s ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

/**
 * Thermal voucher for a cash injection or security withdrawal.
 * Layout: responsable, time, qty × denomination = subtotal, total.
 */
export function printComprobanteMovimientoEfectivo(mov) {
    const printWindow = window.open('', '_blank', 'width=360,height=640');
    if (!printWindow) return false;

    const esIngreso = mov.tipo === 'ingreso' || mov.concepto === 'inyeccion_efectivo';
    const titulo = esIngreso ? 'INYECCIÓN DE EFECTIVO' : 'RETIRO POR SEGURIDAD';
    const tipoLabel = esIngreso ? 'INGRESO' : 'EGRESO';
    const monto = Math.abs(Number(mov.monto) || 0);
    const lines = desgloseLineas(mov.desglose);
    const hora = formatFechaHoraChile(mov.created_at) || '—';
    const responsable = mov.responsable || mov.usuario_nombre || '—';
    const caja = mov.caja_nombre || '—';

    const bodyRows = lines.length
        ? lines
            .map(
                (l) =>
                    `<tr>
                        <td class="qty">${l.qty}</td>
                        <td class="val">${esc(l.label)}</td>
                        <td class="sub">${formatClp(l.subtotal)}</td>
                    </tr>`
            )
            .join('')
        : '<tr><td colspan="3" class="muted">Sin desglose de billetes</td></tr>';

    const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>${esc(titulo)}</title>
<style>
  @page { size: 76mm auto; margin: 4mm; }
  body { font-family: ui-monospace, Consolas, monospace; font-size: 12px; color: #111; width: 68mm; margin: 0 auto; }
  h1 { font-size: 13px; text-align: center; margin: 0 0 4px; }
  .brand { text-align: center; font-weight: 700; font-size: 14px; }
  .tipo { text-align: center; font-size: 11px; letter-spacing: 0.04em; margin-bottom: 8px; }
  .meta { margin: 8px 0; line-height: 1.45; }
  table { width: 100%; border-collapse: collapse; }
  th, td { padding: 2px 0; }
  th { text-align: left; border-bottom: 1px dashed #333; font-size: 11px; }
  td.qty { width: 18%; }
  td.val { width: 42%; }
  td.sub { text-align: right; }
  .total { border-top: 1px solid #111; font-weight: 700; font-size: 13px; }
  .muted { color: #555; font-style: italic; }
  .dash { border-top: 1px dashed #333; margin: 8px 0; }
</style></head><body>
  <div class="brand">SUPER COLCHAGUA</div>
  <h1>${esc(titulo)}</h1>
  <div class="tipo">${tipoLabel}</div>
  <div class="meta">
    <div>Fecha y hora: <strong>${esc(hora)}</strong></div>
    <div>Responsable: <strong>${esc(responsable)}</strong></div>
    <div>Caja: <strong>${esc(caja)}</strong></div>
  </div>
  <div class="dash"></div>
  <table>
    <thead><tr><th>Cant</th><th>Valor</th><th style="text-align:right">Subtotal</th></tr></thead>
    <tbody>
      ${bodyRows}
      <tr class="total"><td colspan="2">TOTAL</td><td class="sub">${formatClp(monto)}</td></tr>
    </tbody>
  </table>
  <div class="dash"></div>
  <p style="text-align:center;font-size:10px;margin-top:10px">Comprobante de movimiento de caja</p>
  <script>window.onload=function(){window.print();setTimeout(function(){window.close();},400);}</script>
</body></html>`;

    printWindow.document.write(html);
    printWindow.document.close();
    return true;
}
